import styled, { withTheme, css } from 'styled-components';

const SIntro = withTheme(styled.main`
  margin-top: ${(props) => props.theme.spacing.rem(4)};
`);

const SSkillSection = withTheme(styled.main`
  margin-top: ${(props) => props.theme.spacing.rem(4)};
  padding-top: ${(props) => props.theme.spacing.rem(4)};
  border-top: 1px solid ${(props) => props.theme.color.border};
`);

const SThemeFilters = withTheme(styled.div`
  margin-bottom: ${(props) => props.theme.spacing.rem(2)};
`);

const SFilters = withTheme(styled.ul`
  margin: ${(props) => props.theme.spacing.rem(1, 0, 2.5)};
  padding: ${(props) => props.theme.spacing.rem(2, 2, 1)};
  border-bottom: 1px solid ${(props) => props.theme.color.border};
  background: ${(props) => props.theme.color.muted.main};
  @media screen and (min-width: ${(props) => props.theme.breakpoints.phablet}) {
    display: flex;
    flex-wrap: wrap;
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints.laptop}) {
    flex-wrap: nowrap;
    justify-content: space-between;
    padding: ${(props) => props.theme.spacing.rem(1, 2)};
  }
`);

const SFilterItem = styled.li`
  margin-bottom: ${(props) => props.theme.spacing.rem(1)};
  @media screen and (min-width: ${(props) => props.theme.breakpoints.phablet}) {
    width: 48%;
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints.tablet}) {
    width: 25%;
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints.laptop}) {
    width: auto;
    margin: 0;
  }
`;
// eslint-disable-next-line jsx-a11y/label-has-associated-control
const SFilterLabel = withTheme(styled(
  ({ isChecked, color, theme, ...rest }) => <label {...rest} />
)`
  position: relative;
  display: flex;
  align-items: center;
  padding-right: ${(props) => props.theme.spacing.baseline(1)};
  text-transform: uppercase;
  font-size: ${(props) => props.theme.font.size.small};
  line-height: 1;
  &::before {
    content: '';
    display: inline-block;
    width: ${(props) => props.theme.spacing.baseline(2)};
    height: ${(props) => props.theme.spacing.baseline(2)};
    margin-right: ${(props) => props.theme.spacing.baseline(1)};
    border: 2px solid ${(props) => props.color.main};
    background: white;
    cursor: pointer;
  }
  ${({ isChecked }) => {
    if (isChecked) {
      return css`
        &::before {
          background: ${(props) => props.color.main};
        }
      `;
    }
    return false;
  }}
`);

const SFilterInput = withTheme(styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`);

const SInfo = withTheme(styled.div`
  margin-top: ${(props) => props.theme.spacing.rem(1)};
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  min-height: 400px;
  @media screen and (min-width: ${(props) => props.theme.breakpoints.desktop}) {
    flex-wrap: nowrap;
  }
`);

const SSkillsList = withTheme(styled.ul`
  width: 30%;
  @media screen and (min-width: ${(props) => props.theme.breakpoints.tablet}) {
    width: 100%;
    padding: ${(props) => props.theme.spacing.rem(2, 0)};
  }
`);

const SSkillsListItem = withTheme(styled(
  ({ theme, color, isSelected, ...rest }) => <li {...rest} />
)`
  display: inline-block;
  width: 100%;
  margin: ${(props) => props.theme.spacing.rem(0, 1, 1, 0)};  
  padding: ${(props) => props.theme.spacing.rem(0.5, 1)};
  background: ${(props) => props.theme.color.muted.main};
  color: ${(props) => props.color.main};
  cursor: pointer;
  ${({ isSelected }) => {
    if (isSelected)
      return css`
        background: ${(props) => props.color.main};
        color: white;
      `;
    return false;
  }}
   @media screen and (min-width: ${(props) => props.theme.breakpoints.tablet}) {
     width: auto;
   }
`);

const SThemeDetails = withTheme(styled.div`
  width: 100%;
  text-align: justify;
  margin-bottom: ${(props) => props.theme.spacing.rem(2)};
  @media screen and (min-width: ${(props) => props.theme.breakpoints.tablet}) {
    width: 57%;
  }
`);

const SDetailsMain = withTheme(styled.div`
  @media screen and (min-width: ${(props) => props.theme.breakpoints.tablet}) {
    display: flex;
    justify-content: space-between;
  }
`);

// eslint-disable-next-line jsx-a11y/heading-has-content
const SThemeTitle = withTheme(styled(({ theme, color, ...rest }) => (
  <h2 {...rest} />
))`
  width: 100%;
  margin-bottom: ${(props) => props.theme.spacing.rem(1)};
  &::before {
    content: '';
    display: inline-block;
    width: ${(props) => props.theme.spacing.baseline(2)};
    height: ${(props) => props.theme.spacing.baseline(2)};
    margin-right: ${(props) => props.theme.spacing.baseline(1)};
    background: ${(props) => props.color.main};
    border: 2px solid ${(props) => props.color.main};
  }
`);

const SSkillDetails = withTheme(styled.div`
  width: 68%;
  @media screen and (min-width: ${(props) => props.theme.breakpoints.tablet}) {
    width: 40%;
  }
`);

const SSkillTitle = withTheme(styled.h3`
  margin-bottom: ${(props) => props.theme.spacing.rem(1)};
  padding: ${(props) => props.theme.spacing.baseline(0.5, 1.5)};
  color: white;
  background: ${(props) => props.color.main};
`);

const SSkillExperience = withTheme(styled.p`
  padding: ${(props) => props.theme.spacing.baseline(0, 1.5)};
`);

const SSkillDescription = withTheme(styled.div`
  margin: ${(props) => props.theme.spacing.rem(1, 0, 0)};
  padding: ${(props) => props.theme.spacing.rem(1.5)};
  background: ${(props) => props.theme.color.muted.main};
  p:last-child {
    margin: 0;
  }
`);

export {
  SIntro,
  SSkillSection,
  SThemeFilters,
  SFilters,
  SFilterItem,
  SFilterLabel,
  SFilterInput,
  SInfo,
  SSkillsList,
  SSkillsListItem,
  SDetailsMain,
  SThemeTitle,
  SThemeDetails,
  SSkillDetails,
  SSkillTitle,
  SSkillExperience,
  SSkillDescription,
};
